<template>
  <div style="overflow: hidden !important;">
    <v-row style="overflow: hidden !important;">
      <v-col cols="12">
        <!-- <v-tabs centered v-model="tabs" background-color="#2463af" dark>
          <v-tab v-for="(item, index) in list_menu" :key="index" @click="toPage(item.path)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-badge color="red" :content="item.count >= 100 ? '+99' : item.count" offset-x="12" offset-y="15"
                  v-if="item.count > 0">
                  <v-icon v-bind="attrs" v-on="on" class="mr-2 fz-18">{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon v-else class="mr-2 fz-18" v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs> -->

        <v-tabs centered v-model="tabs" background-color="#2463af" dark>
          <v-tab @click="toPage('homepage')" class="pt-1">
            <v-col cols="12">
              <v-badge color="red" :content="count_request >= 100 ? '+99' : count_request" offset-x="12" offset-y="15"
                v-if="count_request > 0">
                <v-icon class="mr-2 fz-18">fa-solid fa-house</v-icon>
              </v-badge>
              <v-icon v-else class="mr-2 fz-18" >fa-solid fa-house</v-icon>
              <br>
              <span class="text-transfrom-none">{{ $t('LeftSide.header.homepage') }}</span>
            </v-col>
          </v-tab>
          <v-tab @click="toPage('chat')" class="pt-1">
            <v-col cols="12">
              <v-badge color="red" :content="count_read >= 100 ? '+99' : count_read" offset-x="12" offset-y="15"
                v-if="count_read > 0">
                <v-icon class="mr-2 fz-18">fa-solid fa-comment-dots</v-icon>
              </v-badge>
              <v-icon v-else class="mr-2 fz-18" >fa-solid fa-comment-dots</v-icon>
              <br>
              <span class="text-transfrom-none">{{ $t('LeftSide.header.chat') }}</span>
            </v-col>
          </v-tab>
          <v-tab @click="toPage('setting')" class="pt-1">
            <v-col cols="12">
              <v-icon class="mr-2 fz-18" >fa-solid fa-gear</v-icon>
              <br>
              <span class="text-transfrom-none">{{ $t('LeftSide.header.setting') }}</span>
            </v-col>
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="12" class="border-col-left pt-0">
        <ListChat v-if="page === 'chat'" />
        <ListFriend v-if="page === 'friend'" />
        <ListBusiness v-if="page === 'account'" />
        <Homepage v-if="page === 'homepage'" />
        <Setting v-if="page === 'setting'" />
      </v-col>
    </v-row>
  </div>

</template>
<script>
import { sync } from 'vuex-pathify'
import ListChat from './ListChat.vue';
import ListFriend from './ListFriend.vue';
import ListBusiness from './ListBusiness.vue';
import Setting from './Setting.vue';
import Homepage from './Homepage.vue';
export default {
  data: () => ({
    tabs: 'tab-1',
    page: "homepage",
    list_menu: [],
    list_setting: [
      {
        icon: 'fa-solid fa-gear',
        text: 'setting',
        path: 'setting'
      },
    ],
    data_user: {},
    list_chat: [],
    status_count_read: true,
    status_count_request: true,
  }),
  components: {
    ListChat,
    ListFriend,
    ListBusiness,
    Homepage,
    Setting,
  },
  computed: {
    ...sync('*')
  },
  mounted() {
    // console.log("mounted => ", this.tabs);
    // console.log("page => ", this.page);
    this.page = localStorage.page !== undefined ? localStorage.page : "homepage";
    if (this.page === "homepage") {
      this.tabs = 0
    } else if (this.page === "chat") {
      this.tabs = 1
    } else {
      this.tabs = 2
    }
    this.getCountRequest(this.data_user.tokenuser);
    this.getListChat(this.data_user.tokenuser);
  },
  watch: {
    '$route'() {
      // console.log("route => ", this.$route.hash);
    },
    tabs() {
      // console.log("watch tabs =>", this.tabs);
    },
    count_read() {
      console.log("watch count_read", this.count_read);
      if (this.count_read > 0) {
        this.status_count_read = true;
      } else {
        this.status_count_read = false;
      }
    },
    count_request() {
      // console.log("watch count_request", this.count_request);
      if (this.count_request > 0) {
        this.status_count_request = true;
      } else {
        this.status_count_request = false;
      }
    },
    page() {
      // console.log("watch page =>", this.page);
      localStorage.page = this.page;
    }
  },
  created() {
    // console.log("created count_read", this.count_read);
    // console.log("created count_request", this.count_request);
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    // connection centrifuge
    this.getCountRequest(this.data_user.tokenuser);
    // this.getnotcountread(this.data_user.tokenuser);
    this.getListChat(this.data_user.tokenuser);
    this.list_menu = [
      {
        icon: 'fa-solid fa-house',
        text: this.$t('LeftSide.header.homepage'),
        path: 'homepage',
        count: this.count_request
      },
      {
        icon: 'fa-solid fa-comment-dots',
        text: this.$t('LeftSide.header.chat'),
        path: 'chat',
        count: this.count_read
      },
      {
        icon: 'fa-solid fa-gear',
        text: this.$t('LeftSide.header.setting'),
        path: 'setting'
      },
      // { 
      // 	icon: 'fa-solid fa-calendar-days',
      // 	text: 'calendar',
      // 	path: 'calendar'
      // },
      // { 
      // 	icon: 'fa-solid fa-box-archive',
      // 	text: 'service',
      // 	path: 'service'
      // },
    ]
  },
  methods: {
    toPage(path) {
      // console.log("path", path);
      // window.location.hash = path;
      this.page = path;
      // console.log("route => ", this.$route);
    },
    async getCountRequest(token) {
				await this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-list-pending`, {
					tokenuser: token
				}).then((response) => {
					if (response.data.status === 'success') {
						this.count_request = response.data['list_request_friend'].length + response.data['list_pending_group'].length + response.data['list_send_request_friend'].length
            if (this.count_request > 0) {
              this.status_count_request = true;
            } else {
              this.status_count_request = false;
            }
          }
				}).catch(err => {
					console.log(err)
					this.count_request = 0
				})
			},
			async getListChat (tokenuser) {
        await this.axios.post(process.env.VUE_APP_API_GO + `/v4/getListChat`, {
          tokenuser: tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.listchat = response.data['listchat']
            // pinchat
            var listpin = []
            var linstunpin = []
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
            // count_read
            var indexblock = []
            var indexmessage = []
            var indexactive = []
            indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
            indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
            indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
            var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
            var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
            var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
            var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
            this.count_read = count - (countblock + countmsg + countactive)
            // console.log('this.count_read: ', this.count_read)
            if (this.count_read > 0) {
              this.status_count_read = true;
            } else {
              this.status_count_read = false;
            }
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          this.listchat = []
					this.count_read = 0;
        })
      },
  },
}
</script>
<style scoped>
>>>.v-tab {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex: 0 1 auto;
    font-size: .875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: .0892857143em;
    line-height: normal;
    min-width: 75px;
    max-width: 360px;
    outline: none;
    padding: 0 8px !important;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: none;
    /* -webkit-user-select: none;
    -moz-user-select: none; */
    user-select: none;
}
.text-transfrom-none {
  text-transform: none !important;
}
>>>.v-tabs--icons-and-text>.v-tabs-bar {
  height: 56px !important;
}

.fz-16 {
  font-size: 16px !important;
}

.fz-18 {
  font-size: 18px !important;
}

.position-bottom {
  position: fixed;
  bottom: 50px;
}

.border-col-left {
  border-left-style: solid;
  border-left-width: thin;
  border-left-color: #e2e1e3;
}
</style>